import { useEffect } from 'react'

import styles from './Entrenamiento.module.css'
import DayCard from './DayCard'
import RestTimerBar from './RestTimerBar'
import { useEntrenamientoHead } from './useEntrenamientoHead'
import { useTrainingLog, formatDate, useRestTimer } from '../../hooks'
import { meta, week, days, rules, nutrition } from '../../data/planEntrenamiento'

const Entrenamiento = () => {
  const log = useTrainingLog()
  const { timer, start, stop, toggle, add } = useRestTimer()
  const sessions = log.hydrated ? log.recentSessions() : 0

  useEntrenamientoHead()

  // El CssBaseline de MUI pinta el body en blanco (tema claro del resto del
  // sitio); aquí lo oscurecemos para que el overscroll no muestre una franja.
  useEffect(() => {
    const previous = document.body.style.backgroundColor
    document.body.style.backgroundColor = '#0D1321'
    return () => {
      document.body.style.backgroundColor = previous
    }
  }, [])

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.wrap}>
          <div className={styles.stamp}>{meta.stamp}</div>
          <div className={styles.stampLabel}>{meta.stampLabel}</div>
          <h1 className={styles.h1}>{meta.title}</h1>
          <p className={styles.sub}>{meta.intro}</p>

          <div className={styles.chips}>
            {meta.chips.map((chip) => (
              <span className={styles.chip} key={chip.label}>
                {chip.label} <b>{chip.value}</b>
              </span>
            ))}
            {log.hydrated && (
              <span className={`${styles.chip} ${styles.chipLive}`}>
                Hoy <b>{formatDate(log.today)}</b> · {sessions}{' '}
                {sessions === 1 ? 'sesión' : 'sesiones'} esta semana
              </span>
            )}
          </div>

          <nav className={styles.week} aria-label="Semana">
            {week.map((item) => {
              const content = (
                <>
                  <span className={styles.weekDay}>{item.day}</span>
                  <span className={styles.weekDetail}>{item.detail}</span>
                </>
              )
              const className = [
                styles.weekCell,
                item.gym ? styles.weekGym : '',
                item.sport ? styles.weekSport : '',
              ].join(' ')
              return item.target ? (
                <a className={className} href={`#${item.target}`} key={item.day}>
                  {content}
                </a>
              ) : (
                <div className={className} key={item.day}>
                  {content}
                </div>
              )
            })}
          </nav>
        </div>
      </header>

      <section className={styles.section}>
        <div className={styles.wrap}>
          <p className={styles.eyebrow}>Marca, registra y progresa</p>
          <h2 className={styles.h2}>La rutina semanal</h2>
          {days.map((day) => (
            <DayCard key={day.id} day={day} log={log} onStartRest={start} />
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.wrap}>
          <p className={styles.eyebrow}>Cómo ver resultados</p>
          <h2 className={styles.h2}>Las reglas del juego</h2>
          <div className={styles.rules}>
            {rules.map((rule) => (
              <div className={styles.rule} key={rule.title}>
                <h3>{rule.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: rule.body }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.wrap}>
          <p className={styles.eyebrow}>Protocolo de las 7:00</p>
          <h2 className={styles.h2}>¿Comer antes? ¿Creatina en ayunas?</h2>
          <div className={styles.nutrition}>
            {nutrition.map((card) => (
              <div className={styles.nutCard} key={card.number}>
                <h3>
                  <span>{card.number} ·</span> {card.title}
                </h3>
                <p dangerouslySetInnerHTML={{ __html: card.intro }} />
                <ul>
                  {card.items.map((item) => (
                    <li key={item} dangerouslySetInnerHTML={{ __html: item }} />
                  ))}
                </ul>
                <p className={styles.verdict}>
                  <b>Veredicto:</b> {card.verdict}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className={styles.footer}>
        <div className={styles.wrap}>
          Plan diseñado para Roiner · Tus cargas se guardan en este navegador.{' '}
          <b>La barra no espera.</b>
        </div>
      </footer>

      <RestTimerBar timer={timer} onToggle={toggle} onAdd={add} onStop={stop} />
    </main>
  )
}

export default Entrenamiento
